<template>
  <div class="bottom-switch">
    <div class="ecological-alliance-box bottom-content clearfix">
      <div class="photo-l fl"
           v-if="tagsDataList.length"
           @click="$emit('emitHandleDetail',tagsDataList[0])"
           @contextmenu.stop.prevent="tagsDataList[0].pictures.length&&tagsDataList[0].pictures[0]?$emit('emitContextMenuItem',0,$event):''"
           @touchstart="touchstarts(0)"
           @touchmove="touchmoves()"
           @touchend="touchends()">
        <a href="javascript:;">
          <!-- <img :src="tagsDataList[0].pictures[0]?tagsDataList[0].pictures[0]:require('../../assets/image/images/default_media.jpg')"> -->
          <ZImage :value="tagsDataList[0].pictures[0] ? tagsDataList[0].pictures[0] : ''"
                  :error-src="require('../../assets/image/images/default_media.png')" />
        </a>
      </div>
      <div class="photo-r clearfix"
           v-if="tagsDataList.length">
        <li class="fl"
            v-for="(item,ind) in tagsDataList"
            v-show="ind>0&&ind<7"
            :key="ind"
            @click="$emit('emitHandleDetail',item)"
            @contextmenu.stop.prevent="item.pictures&&item.pictures[ind]?$emit('emitContextMenuItem',ind,$event):''"
            @touchstart="touchstarts(ind)"
            @touchmove="touchmoves()"
            @touchend="touchends()">
          <a href="javascript:;">
            <!-- <img :src="item.pictures[0]?item.pictures[0]:require('../../assets/image/images/default_media.png')"> -->
            <ZImage :value="item.pictures[0]?item.pictures[0]:''"
                    :error-src="require('../../assets/image/images/default_media.png')" />
          </a>
        </li>
      </div>
    </div>
  </div>
</template>
<script>
import ZImage from "../ZImage.vue"
export default {
  name: 'enterpris',
  components: {
    ZImage
  },
  props: {
    tagsDataList: {
      type: Array
    }
  },
  data () {
    return {
      timeOutEvent: 0
    }
  },
  mounted () {
    console.log(this.tagsDataList);
  },
  methods: {
    touchstarts (ind) {
      var _this = this;
      // 长按事件触发
      clearTimeout(_this.timeOutEvent);
      _this.timeOutEvent = setTimeout(function () {
        _this.timeOutEvent = 0;
        _this.$emit('emitContextMenuItem', ind);
      }, 400);
      //长按400毫秒
      // e.preventDefault();
    },
    touchmove: function () {
      clearTimeout(this.timeOutEvent);
      this.timeOutEvent = 0;
    },
    touchend: function (e) {
      clearTimeout(this.timeOutEvent);
      return false;
    }
  }
}

</script>
<style scoped>
/* 企业联盟 区块CSS */

/*使区块在1080编辑下不会掉出或隐藏*/

.bottom-content {
  /* padding: 18px; */
  height: 100%;
}
.ecological-alliance-box a {
  display: block;
  width: 100%;
  height: 100%;
  text-align: center;
}
.ecological-alliance-box .photo-l {
  width: 310px;
  height: 231px;
  background: #fafafa;
  font-size: 0;
}
.ecological-alliance-box .photo-l img {
  width: 100%;
  max-height: 100%;
  mix-blend-mode: multiply;
  vertical-align: middle;
}
.ecological-alliance-box .photo-r {
  width: 800px;
}
.ecological-alliance-box .photo-r li {
  display: block;
  margin: 0px 0 15px 10px;
}
.ecological-alliance-box .photo-r li a {
  font-size: 0;
  width: 145px;
  height: 108px;
  line-height: 108px;
  background: #fafafa;
  float: left;
}

.ecological-alliance-box .photo-r li a img {
  width: 100%;
  height: 100%;
  mix-blend-mode: multiply;
  vertical-align: middle;
}
@media screen   and (max-width: 768px) {
  .ecological-alliance-box {
    height: auto !important;
  }
  .ecological-alliance-box .photo-l {
    margin: 0 0 15px 0px;
    width: 100%;
  }
  .ecological-alliance-box .photo-r {
    width: 100%;
  }
  .ecological-alliance-box .photo-r li {
    display: block;
    width: calc(50% - 7px);
    width: -webkit-calc(50% - 7px);
    margin: 0px 0 15px 12px;
  }
  .ecological-alliance-box .photo-r li a {
    width: 100%;
  }
  .ecological-alliance-box .photo-r li:nth-of-type(even) {
    margin-left: 0px;
  }
}
</style>>



// WEBPACK FOOTER //
// src/components/floorBlock/enterpris.vue